import React from 'react'
import './Fourzero.scss';

function Fourzero() {
    return (
        <div className="fourzero-parent parent">
            <div className="fourzero-container container">
                <div className="fourzero-box">
                    <h2 className='for-heading'>404</h2>
                    <div className="line"></div>
                    <p className='four-p'>This page could not be found</p>
                </div>
            </div>
        </div>
    )
}

export default Fourzero